import React from 'react';
import Icon from '../../../components/AppIcon';
import { format, differenceInDays } from 'date-fns';

const MobileProjectCard = ({ project, onEdit }) => {
  const today = new Date();
  const daysUntilDelivery = differenceInDays(new Date(project.deliveryDate), today);
  
  const getStatusConfig = () => {
    if (daysUntilDelivery < 0) {
      return { 
        status: 'Overdue', 
        color: 'bg-red-200', 
        textColor: 'text-red-900',
        icon: 'AlertCircle'
      };
    } else if (daysUntilDelivery <= 7) {
      return { 
        status: 'Due Soon', 
        color: 'bg-yellow-200', 
        textColor: 'text-yellow-900',
        icon: 'Clock'
      };
    } else {
      return { 
        status: 'On Track', 
        color: 'bg-green-200', 
        textColor: 'text-green-900',
        icon: 'CheckCircle2'
      };
    }
  };

  const statusConfig = getStatusConfig();
  const duration = differenceInDays(new Date(project.deliveryDate), new Date(project.startDate));

  return (
    <div className="bg-white rounded-xl shadow-elevation-2 p-4 mb-4">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-foreground mb-1 truncate">
            {project?.clientName}
          </h3>
          <div className="text-sm text-muted-foreground">
            ₹{project?.projectValue?.toLocaleString()}
          </div>
        </div>
        <button
          onClick={() => onEdit(project)}
          className="w-10 h-10 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-smooth flex-shrink-0 ml-2"
          aria-label="Edit project"
        >
          <Icon name="Edit2" size={18} />
        </button>
      </div>
      <div className={`${statusConfig?.color} ${statusConfig?.textColor} rounded-lg px-3 py-2 mb-3 flex items-center gap-2`}>
        <Icon name={statusConfig?.icon} size={16} />
        <span className="text-sm font-medium">{statusConfig?.status}</span>
      </div>
      <div className="space-y-2">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Calendar" size={16} className="text-muted-foreground" />
          <span className="text-muted-foreground">Start:</span>
          <span className="text-foreground font-medium">
            {format(new Date(project.startDate), 'MMM d, yyyy')}
          </span>
        </div>
        
        <div className="flex items-center gap-2 text-sm">
          <Icon name="CalendarCheck" size={16} className="text-muted-foreground" />
          <span className="text-muted-foreground">Delivery:</span>
          <span className="text-foreground font-medium">
            {format(new Date(project.deliveryDate), 'MMM d, yyyy')}
          </span>
        </div>

        <div className="flex items-center gap-2 text-sm">
          <Icon name="Clock" size={16} className="text-muted-foreground" />
          <span className="text-muted-foreground">Duration:</span>
          <span className="text-foreground font-medium">
            {duration} days
          </span>
        </div>

        {daysUntilDelivery >= 0 && (
          <div className="flex items-center gap-2 text-sm">
            <Icon name="Timer" size={16} className="text-muted-foreground" />
            <span className="text-muted-foreground">Days remaining:</span>
            <span className="text-foreground font-medium">
              {daysUntilDelivery} days
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileProjectCard;